/**
 * Created by michael on 10/9/17.
 */

var defaultSlickSettings = {
    // slidesToShow: 5,
    // slidesToScroll: 5
};

jQuery(function ($) {

    if (typeof SLICK_SETTINGS !== 'undefined') {
        console.log(SLICK_SETTINGS);
        slickSettings = $.extend({}, true, defaultSlickSettings, SLICK_SETTINGS);
    }
    else {
        slickSettings = defaultSlickSettings;
    }

    console.log(slickSettings);

    $('.slick-logo-scroller').slick(slickSettings);

});